// Safe wrapper around the OpenAI Ads Pixel (oaiq SDK loaded in index.html).
// No-ops gracefully if oaiq isn't available (e.g. content blockers) and never throws,
// mirroring the defensive style of metaPixel.js / ga4.js.

export function trackOaiPageView() {
  try {
    if (typeof window !== 'undefined' && typeof window.oaiq === 'function') {
      window.oaiq('measure', 'page_viewed', { type: 'customer_action' });
    }
  } catch (e) {
    // analytics must never break the user experience
  }
}

export function trackOaiLead() {
  try {
    if (typeof window !== 'undefined' && typeof window.oaiq === 'function') {
      window.oaiq('measure', 'lead_created', { type: 'customer_action' });
    }
  } catch (e) {
    // analytics must never break the user experience
  }
}